import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CardRoomIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Card Room`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M14.215 3.7 8.453.22c-.75-.453-1.709-.184-2.143.6l-5.1 9.24c-.433.784-.176 1.787.575 2.24l5.762 3.48c.75.453 1.709.184 2.143-.6l5.1-9.24c.433-.784.176-1.787-.575-2.24ZM10.41 9.418c-.796 1.341-2.46.897-2.679-.551l-.1 2.573-2.31-1.395 2.017-1.335c-1.267.415-2.506-.85-1.716-2.183.904-1.522 3.524-1.145 4.244-1.898-.241.941 1.408 3.33.544 4.789Z"
    />
  </Icon>
);
